import React from 'react';
import { useEditorThemeContext } from '../../../../hooks/use-editor-theme';
import { MessageContainer as MessageContainerStyled, MessageList } from './styled';

// Max number messages we want to show
var MAX_MESSAGES = 10;
export var MessageContainer = function MessageContainer(_ref) {
  var children = _ref.children;
  var _useEditorThemeContex = useEditorThemeContext(),
    isSearch = _useEditorThemeContex.isSearch;
  return /*#__PURE__*/React.createElement(MessageContainerStyled, {
    isSearch: isSearch
  }, children);
};
export var FormatMessages = function FormatMessages(_ref2) {
  var messages = _ref2.messages;
  if (messages.length === 0) {
    return null;
  }
  if (messages.length === 1) {
    return /*#__PURE__*/React.createElement("span", null, messages[0].message);
  }
  return /*#__PURE__*/React.createElement(MessageList, null, messages.slice(0, MAX_MESSAGES).map(function (m, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i
    }, m.message);
  }));
};